import { makeObservable, observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'

import i18n from 'modules/core/lib/i18n'

export type BlockConfig = {
  title?: string
  uuid?: string
}

export abstract class Block {
  title: string
  uuid: string

  constructor(config: BlockConfig) {
    this.title = config.title || ''
    this.uuid = config.uuid || uuidv4()

    makeObservable(this, {
      title: observable,
    })
  }

  abstract clone(): Block

  validate(): Record<string, string> {
    const errors: Record<string, string> = {}
    if (!this.title.trim()) {
      errors.title = i18n.t('trainings.content.validation.title_required')
    }
    return errors
  }
}
